import { Directive, HostListener, Input } from '@angular/core';

@Directive({ selector: '[appRoundDecimals]' })
export class RoundDecimalsDirective {
  @Input() decimals = 2;
  @Input() maxValue: number | null = null;

  @HostListener('blur', ['$event.target'])
  onBlur(input: HTMLInputElement): void {
    const rawValue = parseFloat(input.value);
    if (isNaN(rawValue)) return;

    const factor = Math.pow(10, this.decimals);
    let rounded = Math.round(rawValue * factor) / factor;

    if (this.maxValue !== null && rounded > this.maxValue) {
      rounded = this.maxValue;
    }

    input.value = String(rounded);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
